
<!-- Footer -->
<div class="footer">
  <div class="footer-content container">
    <div class="row">
      <div class="col-lg-5">
        <div class="footer-about-item">
          <div class="ftrabout-head">
            <h2>ABOUT US</h2>
          </div>
          <div class="ftrabout-details">
            <p>
              We are a worldwide society of 1000+ members who share a passion
              for the preservation of antique phonographs, gramophones and
              records. We encourage, promote, publish and present research on
              the history of sound recording and reproduction, including the
              machines that create and preserve these wonderful voices and
              sounds. The Society maintains informative articles on its website
              as well as an exhaustive online searchable archive of over 30,000
              pages of phonograph and record research material available to
              members. We publish a full-color quarterly journal called The
              Antique Phonograph. The APS also sponsors an annual antique
              phonograph/record Expo and banquet, to which all are welcome.
              Additional information about our organization and governance can
              be found <a routerLink="/antique-phonograph-society-mission-statement">here.</a>
            </p>
          </div>
        </div>
      </div>
      <div class="col-lg-4 box-line">
        <div class="ftrcontact-item">
          <div class="ftrcontact-head">
            <h2>CONTACT US</h2>
          </div>
          <div class="ftrcontact-details">
            <p class="bold">Antique Phonograph Society</p>
            <p>
              P.O. Box 169, Victorville, CA 92393 <br> United States<br> Email
              us at: <a style="color: #fff;" href="mailto:info@antiquephono.org">info@antiquephono.org</a> 
            </p>
            <a routerLink="/link" class="link-item-btn">LINKS</a> <br />
            <a routerLink="/advisoryboard" class="link-item-btn mrg-top"
              >Board of Directors/Advisory Board</a
            >
            <a href="https://apsblobdeve.blob.core.windows.net/aps-website-files/Regional%20Phonograph%20Societies.pdf" target="_blank" class="link-item-btn mrg-top"
            >Regional Societies </a>
          </div>
        </div>
      </div>
      <div class="col-lg-3">
        <div class="social-head">
          <h2>SOCIAL</h2>
        </div>
        <div class="social-details">
          <div class="row">
            <div class="col-lg-6 col-3">
              <div class="social-icons">
                <a href="https://www.facebook.com/groups/phonograph/" target="_blank">
                  <img src="assets/image/Group 255.svg" alt="" srcset="" />
                </a>                
              </div>
            </div>
            <div class="col-lg-6 col-3">
              <div class="social-icons">
                <a href="https://www.instagram.com/antiquephonosociety/?utm_medium=copy_link" target="_blank"
                  ><img src="assets/image/Group 213.svg" alt="" srcset=""
                /></a>
              </div>
            </div>
            <!-- <div class="col-lg-6 col-3">
              <div class="social-icons">
                <a href="#"
                  ><img src="assets/image/Group 217.svg" alt="" srcset=""
                /></a>
              </div>
            </div>
            <div class="col-lg-6 col-3">
              <div class="social-icons">
                <a href="#"
                  ><img src="assets/image/Group 256.svg" alt="" srcset=""
                /></a>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- footer link  -->
<div class="footer-Copyright">
  <p>Copyright ©{{year}} | The Antique Phonograph Society</p>
</div>
